export const CATEGORIES = [
  { displayName: 'Box Rental', key: 'box_rental', files: [] },
  { displayName: 'Computer Rental', key: 'computer_rental' },
  { displayName: 'Car Allowance', key: 'car_allowance' },
  { displayName: 'Mobile Phone', key: 'mobile_phone' },
  { displayName: 'Housing Allowance', key: 'housing_allowance' },
  { displayName: 'Other', key: 'other' },
];
